import { ReactNode, FC } from "react";
import { Navigate } from "react-router-dom";
import { isAuth } from "../../utils";

interface IProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: FC<IProtectedRouteProps> = ({ children }) => {
  if (!isAuth()) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
